var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-switch',{attrs:{"checked-children":_vm.checkName ? _vm.checkName : '是',"un-checked-children":_vm.unCheckName ? _vm.unCheckName : '否',"disabled":_vm.disabled},on:{"click":_vm.click},model:{value:(_vm.thisValue),callback:function ($$v) {_vm.thisValue=$$v},expression:"thisValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }